"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankstatementsToJSON = exports.BankstatementsFromJSONTyped = exports.BankstatementsFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function BankstatementsFromJSON(json) {
    return BankstatementsFromJSONTyped(json, false);
}
exports.BankstatementsFromJSON = BankstatementsFromJSON;
function BankstatementsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'circle': !(0, runtime_1.exists)(json, 'circle') ? undefined : (0, _1.BankstatementsCircleDataFromJSON)(json['circle']),
        'table': !(0, runtime_1.exists)(json, 'table') ? undefined : (0, _1.BankstatementsTableFromJSON)(json['table']),
        'allowPaylink': !(0, runtime_1.exists)(json, 'allowPaylink') ? undefined : json['allowPaylink'],
        'timeslots': !(0, runtime_1.exists)(json, 'timeslots') ? undefined : (json['timeslots'].map(_1.BankstatementsTimeslotsFromJSON)),
    };
}
exports.BankstatementsFromJSONTyped = BankstatementsFromJSONTyped;
function BankstatementsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'circle': (0, _1.BankstatementsCircleDataToJSON)(value.circle),
        'table': (0, _1.BankstatementsTableToJSON)(value.table),
        'allowPaylink': value.allowPaylink,
        'timeslots': value.timeslots === undefined ? undefined : (value.timeslots.map(_1.BankstatementsTimeslotsToJSON)),
    };
}
exports.BankstatementsToJSON = BankstatementsToJSON;
//# sourceMappingURL=Bankstatements.js.map